import axios from "axios";
import { clearToken, getToken } from "../utils/auth";
// Development
// const API_BASE_URL = "http://192.168.29.46:8086/api/web";

//  Production
const API_BASE_URL = "https://confidaysapi.rayfog.com/api/web";


const apiAuthClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

/* ================= REQUEST ================= */
apiAuthClient.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

/* ================= RESPONSE ================= */
// apiAuthClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       console.warn("Unauthorized — clearing token");

//       clearToken();

//       // window.location.href = "/";
//     }

//     return Promise.reject(error);
//   },
// );


apiAuthClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Unauthorized — clearing token");

      clearToken();

      window.location.href = "/";
    }

    return Promise.reject(error);
  },
);


export default apiAuthClient;
